import { cn } from "~/lib/utils";

import { ErrorProps, FormError } from ".";
import { ReactSignature } from "../ui";

interface Props {
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  onChange: (option: string | undefined) => void;
}

const FormSignatureInput = ({ label, required, errors, onChange }: Props) => (
  <div>
    <div className="space-y-1 text-left capitalize">
      <div
        className={cn("text-sm font-medium", {
          "text-danger-500": errors?.error,
        })}
      >
        {label} {required && <span className="text-danger-400">*</span>}
      </div>

      <div>
        <ReactSignature
          onChange={onChange}
          className={cn("", {
            "border-danger-500": errors?.error,
          })}
        />
      </div>
      <FormError error={errors?.error} message={errors?.message} />
    </div>
  </div>
);

export default FormSignatureInput;
